import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';

export default function useRefreshTokenV2() {
  const { state } = useProvider();

  const args = state;

  return useQuery({
    queryKey: [],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/v1/auth/accounts/refresh-token',
      });

      return data?.data;
    },
    refetchInterval: (data) => (data?._isEmailAddressVerified ? false : 1000),
  });
}
